/* eslint-disable react/no-unused-state */
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ViewportSize } from '../viewport/Viewport';
import withViewport from '../viewport/withViewport';

export const FormContext = React.createContext(null);

class Form extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    focusFirstInput: PropTypes.bool,
    onBeforeSubmit: PropTypes.func,
    isDemoPreview: PropTypes.bool,
    onSubmit: PropTypes.func,
    viewport: PropTypes.object.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    children: null,
    disabled: false,
    focusFirstInput: true,
    isDemoPreview: false,
    onBeforeSubmit: () => {},
    onSubmit: () => {},
    className: '',
  };

  constructor(props) {
    super(props);

    this.validateInputs = [];
    this.inputs = [];

    this.state = {
      formSubmitted: false,
      onValidateInputAddedToForm: this.onValidateInputAddedToForm,
      onInputAddedToForm: this.onInputAddedToForm,
    };
  }

  onValidateInputAddedToForm = (input) => {
    this.validateInputs = this.validateInputs.concat(input);
  };

  onInputAddedToForm = (input) => {
    const { isDemoPreview, viewport } = this.props;
    const isDesktop = viewport.size === ViewportSize.DESKTOP;

    this.inputs = this.inputs.concat(input);

    if (this.inputs.length === 1 && this.props.focusFirstInput && isDesktop && !isDemoPreview) {
      input.focus();
      setTimeout(() => {
        const inputVal = input.value;
        input.value = '';
        input.value = inputVal;
      }, 10);
    }
  };

  isValid = () => {
    let isValid = true;

    this.validateInputs.forEach((input) => {
      if (!input.state.valid || (input.props?.type === 'address-autocomplete' ? input.props.validator(input.props.value) : (input.input && input.input.input && input.props.validator(input.input.input.value) !== ''))) {
        isValid = false;
        input.validate();
      }
    });

    return isValid;
  };

  onSubmit = (event) => {
    event.preventDefault();

    const { disabled } = this.props;
    if (disabled) return;

    this.setState({ formSubmitted: true });

    this.props.onBeforeSubmit();

    if (this.isValid()) {
      this.props.onSubmit();
    }
  };

  render() {
    return (
      <FormContext.Provider value={this.state}>
        <form onSubmit={this.onSubmit} noValidate className={classnames(this.props.className)}>
          {this.props.children}
        </form>
      </FormContext.Provider>
    );
  }
}

const FormWithViewport = withViewport()(Form);

const ForwardingComponent = React.forwardRef((props, ref) => {
  const { isDemoPreview } = useSelector(state => state.app);
  return (
    <FormWithViewport ref={ref} {...props} isDemoPreview={isDemoPreview} />
  );
});

export default ForwardingComponent;
